<template>
  <VsButton
    :href="action.url"
    :icon="action.icon"
    class="profile-actions-button"
    :tracker="action.tracker"
    @click="action.action"
  >
    {{ action.label }}
  </VsButton>
</template>

<script>
import VsButton from '@/scripts/Components/Molecules/VsButton';

export default {
  components: {
    VsButton,
  },
  props: {
    action: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/stylesheets/exports/_component-entry';

// General styling
.profile-actions-button {
  overflow: hidden;
  white-space: nowrap;
  border: 1px solid rgba(0,0,0,0);
  margin-top: 4px;
  font-size: 1.6em;
  opacity: 0.6;
  width: 1.8em;

  // Spacing
  padding: 6px 10px;
  margin-left: 0;
  margin-right: 0;

  > * {
    vertical-align: middle;
    font-size: 1em;
  }

  /deep/ .vs-icons {
    margin-right: 4px;
    transition: margin-right 0.25s;
    opacity: 0.8;
  }

  /deep/ .vs-button__text {
    display: none;
  }
}

@include media-breakpoint-up(md) {
  .profile-actions-button {
    font-size: 0.8em;
    border: 1px solid rgba(0,0,0,0.2);
    opacity: 1;
    width: initial;

    // Spacing
    padding: 6px 6px;
    margin-left: 4px;
    margin-right: 4px;

    /deep/ .vs-button__text {
      display: inline-block;
    }
  }
}
</style>
